import axios from 'axios';
import Config from '../config';

const baseURL = `${Config.URL_SERVER}/api`;

const instance = axios.create({
    baseURL,
    headers: { Accept: 'application/json'},
    withCredentials: true,
});

class AxiosHelper {
    static async verifyLicense() {
        return await instance.get('/license/verify');
    }

    static async uploadLicense(data) {
        const headers = { 'Content-Type': 'multipart/form-data'};
        return await instance.post('/license/upload', data, {headers});
    }

    static async login(data) {
        return await instance.post('/auth/signin', data);
    }

    static async signOut() {
        return await instance.post('/auth/signout');
    }

    static async signUp(data) {
        return await instance.post('/auth/signup', data);
    }

    static async refresh() {
        return await instance.get('/auth/refresh');
    }

    static async resetPassword(data) {
        return await instance.post('/auth/reset-password', data);
    }

    static async changePassword(data) {
        return await instance.post('/auth/change-password', data);
    }
}

export default AxiosHelper;